import { DocumentReference } from '.';

export class AgeGroup {
    id: string;
    displayName: string;
    isParent: boolean;
    order?: number;
    yearLevelList: DocumentReference[];
}
